<template>
  <div class="header-menu">
    <!-- 主nav -->
    <header class="main_nav cell">
      <div class="container">
        <!-- 隐藏域用于判定导航栏模块的高亮 -->
        <input
          type="hidden"
          name="nav_link_active"
          id="nav_link_active"
          value=""
        />
        <div class="main_logo">
          <router-link to="/">
            <img src="../../assets/banner_logo.png" alt="" />
          </router-link>
        </div>
        <ul class="nav_list">
          <li
            class="list_item index_item"
            id="index_link_active"
            :class="{ link_active: current_nav.includes('home') }"
          >
            <router-link to="/">
              <p class="item_text">首页</p>
            </router-link>
          </li>
          <li
            class="list_item product_center_item"
            id="product_link_active"
            :class="{ link_active: current_nav.includes('product') }"
          >

            <router-link :to="`/product/list/0-0-0-0-0/`">
                  <p class="item_text">产品中心</p>
            </router-link>
          </li>
          <li
            class="list_item decorate_community_item"
            id="bbs_link_active"
            :class="{ link_active: current_nav.includes('bbs') }"
          >
            <router-link to="/bbs">
              <!-- <a href="javascript:void(0)" onClick="alert('系统维护中，稍后开放')"> -->
              <p class="item_text">装修社区</p>
            </router-link>
          </li>

          <li
            class="list_item one_to_one_design_item"
            id="design_link_active"
            :class="{ link_active: current_nav.includes('design') || current_nav.includes('albums') }"
          >
            <router-link to="/albums/0-0-0-0-0-0-0-0/">
              <p class="item_text">设计支持</p>
            </router-link>
          </li>
          <li
            class="list_item service_support_item"
            id="support_link_active"
            :class="{ link_active: current_nav.includes('store') || current_nav.includes('download') }"
          >
            <router-link to="/store/0-0-0">
              <p class="item_text">经销支持</p>
            </router-link>
          </li>
          <li
            class="list_item walk_into_jinduo_item"
            id="walk_link_active"
            :class="{ link_active: current_nav.includes('about') }"
          >
            <router-link to="/about/intro.html">
              <p class="item_text">走进金舵</p>
            </router-link>
          </li>
          <li
            class="list_item contact_us_item"
            id="contactus_link_active"
            :class="{ link_active: current_nav.includes('contact') }"
          >
            <router-link to="/contact">
              <p class="item_text">联系我们</p>
            </router-link>
          </li>
          <button
            v-if="designer && designer.user_id"
            style="
              font-size:14px;
              border-radius: 5px;
              background-color: rgb(66, 67, 75);
              color: rgb(255, 255, 255);
              width: 100px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              display: inline-block;
              cursor: pointer;
            "
            @click="goDesign"
          >
            在线设计
          </button>
        </ul>
      </div>
    </header>

    <!-- 二级nav 产品中心 -->
    <section class="dropDown_product_center">
    <!-- <section> -->
      <div class="container">
        <div class="ordinary_show">
          <div class="ordinary_show_flexBox">
            <div class="params_class">
                <!-- 系列 -->
                <div class="param">
                  <p class="param_title">
                    <img
                        class="Icon_class"
                        src="@/assets/nav_series.png"
                        alt="按系列分"
                      />按系列分
                  </p>
                  <ul class="param_list">
                    <li
                      class="param_list_item"
                      v-for="(vo, index) in nav.series.slice(0,12)"
                      :key="`series${index}`"
                    >
                    <router-link :to="getURL('series_id',vo.id)">
                      {{ vo.name }}
                    </router-link>

                    </li>
                    <li v-if="nav.series.length > 12" class="param_list_item more">
                      <router-link :to="`/product/list/0-0-0-0-0`">更多 <img src="https://resource.jinduo.com/upload/jinduo/image/20220819/01761ea1a77ef00829f2aacd868be8fa.png"></router-link>
                    </li>
                  </ul>
                </div>
                <!-- 品类 -->
                <div class="param">
                  <p class="param_title">
                    <img
                        class="Icon_class"
                        src="@/assets/nav_categorys.png"
                        alt="按产品类别分"
                      />按产品类别分
                  </p>
                  <ul class="param_list">
                    <!-- {foreach name="nav.categorys" item="val"} -->
                    <li
                      class="param_list_item"
                      v-for="(vo, index) in nav.categorys.slice(0,12)"
                      :key="`categorys${index}`"
                    >
                    <router-link :to="getURL('cate_id', vo.id)" >
                      {{ vo.name }}
                    </router-link>

                    </li>
                    <li v-if="nav.categorys.length > 12" class="param_list_item more">
                      <router-link :to="`/product/list/0-0-0-0-0`">更多 <img src="https://resource.jinduo.com/upload/jinduo/image/20220819/01761ea1a77ef00829f2aacd868be8fa.png"></router-link>
                    </li>
                  </ul>
                </div>
                <!-- 风格 -->
                <div class="param">
                  <p class="param_title">
                    <img
                        class="Icon_class"
                        src="@/assets/nav_styles.png"
                        alt="按装修风格分"
                      />按装修风格分
                  </p>
                  <ul class="param_list">
                    <!-- {foreach name="nav.styles" item="val"} -->
                    <li
                      class="param_list_item"
                      v-for="(vo, index) in nav.styles.slice(0,12)"
                      :key="`styles${index}`"
                    >
                    <router-link :to="getURL('style_id', vo.id)" >
                      {{ vo.name }}
                    </router-link>                    
                    </li>
                    <li v-if="nav.styles.length > 12" class="param_list_item more">
                      <router-link :to="`/product/list/0-0-0-0-0`">更多 <img src="https://resource.jinduo.com/upload/jinduo/image/20220819/01761ea1a77ef00829f2aacd868be8fa.png"></router-link>
                    </li>
                  </ul>
                </div>
            </div>
          </div>
        </div>
        <!-- 系列的更多 -->
        <!-- <div class="more_show">
      <div class="more_show_flexBox">
        <ul class="series_classification">
          {volist name="nav.series" id="val" offset="14"}
          <li class="series_classification_item">
            <a href="{:url('product/product_search',array('series_select'=>$val['id']))}">
              <img src="{$val.nav_series_img}" alt="">
              <div class="item_text">#</div>
            </a>
          </li>
          {/volist}
        </ul>
      </div>
    </div>
    <i class="iconfont animation_navArrow_up">&#xe600;</i> -->
      </div>
    </section>
    <!-- 二级nav 装修社区 -->
    <!--   <section class="dropDown_decorate_community">
    <div class="container">
      <ul class="dropDown_decorate_community_list">
        <li class="dropDown_decorate_community_listItem">
          <div class="listItem_info">
            <a href="{:url('bbs/decorate_bbs')}">
              <i class="iconfont">&#xe73b;</i>
              <span class="listItem_text">装修攻略</span>
            </a>
          </div>
        </li>
        <li class="dropDown_decorate_community_listItem">
          <div class="listItem_info">
            <a href="{:url('bbs/decorate_bbs')}">
              <i class="iconfont">&#xe765;</i>
              <span class="listItem_text">家居设计</span>
            </a>
          </div>
        </li>
        <li class="dropDown_decorate_community_listItem">
          <div class="listItem_info">
            <a href="{:url('bbs/decorate_bbs')}">
              <i class="iconfont">&#xe602;</i>
              <span class="listItem_text">装修论坛</span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </section> -->

    <!-- 二级nav  经销门店 -->
    <section class="dropDown_offline_store">
      <div class="container">
        <!-- <ul class="dropDown_offline_store_list">
      <li class="dropDown_offline_store_listItem">
        <div class="listItem_info">
          <a href="{:url('store/store_query')}">
            <i class="iconfont">&#xe65f;</i>
            <span class="listItem_text">网点分布</span>
          </a>
        </div>
      </li>
      <li class="dropDown_offline_store_listItem">
          <div class="listItem_info">
            <a href="#">
              <i class="iconfont">&#xe60c;</i>
              <span class="listItem_text">门店展示</span>
            </a>
          </div>
        </li>
      <li class="dropDown_offline_store_listItem">
        <div class="listItem_info">
          <a href="{:url('design/free_design')}">
            <i class="iconfont">&#xe612;</i>
            <span class="listItem_text">免费设计</span>
          </a>
        </div>
      </li>
    </ul> -->
      </div>
    </section>

    <!-- 二级nav  设计支持 -->
    <section class="free_design_sub">
      <div class="container">
        <ul class="free_design_sub_list">
          <li class="free_design_sub_listItem">
              <div class="listItem_info">
                <router-link to="/albums/0-0-0-0-0-0-0-0/">
                  <!-- <i class="iconfont">&#xe616;</i> -->
                  <img
                    class="d"
                    src="@/assets/home/albums_g.png"
                    alt="设计案例" 
                  />
                  <img
                    class="h"
                    src="@/assets/home/albums.png"
                    alt="设计案例" 
                  />
                  <span class="listItem_text">设计案例</span>
                </router-link>
              </div>
            </li>
          <li class="free_design_sub_listItem">
            <div class="listItem_info">
              <router-link to="/designers/0-0-1-0-0/">
                <!-- <i class="iconfont">&#xe612;</i> -->
                <img
                  class="d"
                  src="@/assets/home/designers_g.png"
                  alt="设计案例" 
                />
                <img
                  class="h"
                  src="@/assets/home/designers.png"
                  alt="找设计师" 
                />
                <span class="listItem_text">找设计师</span>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- 二级nav 经销支持 -->
    <section class="service_support">
      <div class="container">
        <ul class="service_support_list">
          <!-- <li class="service_support_listItem">
          <div class="listItem_info">
            <a href="#">
              <i class="iconfont">&#xe60e;</i>
              <span class="listItem_text">售后服务</span>
            </a>
          </div>
        </li> -->
          <!-- <li class="service_support_listItem">
          <div class="listItem_info">
            <a href="#">
              <i class="iconfont">&#xe631;</i>
              <span class="listItem_text">防伪溯源</span>
            </a>
          </div>
        </li> -->
          <!-- <li class="service_support_listItem">
          <div class="listItem_info">
            <a href="#">
              <i class="iconfont">&#xe60d;</i>
              <span class="listItem_text">活动专区</span>
            </a>
          </div>
        </li> -->
          <li class="service_support_listItem">
            <div class="listItem_info">
              <router-link to="/store/0-0-0">
                <i class="iconfont">&#xead3;</i>
                <span class="listItem_text">门店服务</span>
              </router-link>
            </div>
          </li>

          <li class="service_support_listItem">
            <div class="listItem_info">
              <router-link to="/download">
                <i class="iconfont">&#xe66c;</i>
                <span class="listItem_text">经销专区</span>
              </router-link>
            </div>
          </li>

          <!-- <li class="service_support_listItem">
            <div class="listItem_info">
              <a href="http://www.sjyuan.cn" target="__blank">
                <i class="iconfont">&#xe765;</i>
                <span class="listItem_text">设计园</span>
              </a>
            </div>
          </li> -->
        </ul>
      </div>
    </section>

    <!-- 二级nav 走进金舵 -->
    <section class="walk_into_jinduo_nav">
      <div class="container">
        <ul class="walk_into_jinduo_list">
          <li class="walk_into_jinduo_listItem">
            <div class="listItem_info">
              <router-link to="/about/intro.html">
                <i class="iconfont">&#xe71c;</i>
                <span class="listItem_text">企业介绍</span>
              </router-link>
            </div>
          </li>
          <li class="walk_into_jinduo_listItem">
            <div class="listItem_info">
              <router-link to="/about/progress.html">
                <i class="iconfont">&#xe632;</i>
                <span class="listItem_text">发展历程</span>
              </router-link>
            </div>
          </li>
          <li class="walk_into_jinduo_listItem">
            <div class="listItem_info">
              <router-link to="/about/honour.html">
                <i class="iconfont">&#xe68d;</i>
                <span class="listItem_text">荣誉资质</span>
              </router-link>
            </div>
          </li>
          <li class="walk_into_jinduo_listItem">
            <div class="listItem_info">
              <router-link to="/about/news.html?type=401">
                <i class="iconfont">&#xe605;</i>
                <span class="listItem_text">动态新闻</span>
              </router-link>
            </div>
          </li>
          <!-- <li class="walk_into_jinduo_listItem" style="display:none;">
            <div class="listItem_info">
              <router-link to="/about/500">

                <i class="iconfont">&#xe665;</i> 
                <span class="listItem_text">生产标准</span>
              </router-link>
            </div>
          </li> -->

          <!-- <li class="walk_into_jinduo_listItem">
        <div class="listItem_info">
          <a href="{:url('support/production_standard')}">
            <i class="iconfont">&#xe665;</i>
            <span class="listItem_text">生产标准2</span>
          </a>
        </div>
      </li> -->
        </ul>
      </div>
    </section>

    <!-- 二级nav 联系我们 -->
    <!-- <section class="contact_us_nav">
  <div class="container">
    <ul class="walk_into_jinduo_list">
      <li class="walk_into_jinduo_listItem">
        <div class="listItem_info">
          <a href="#">
            <i class="iconfont">&#xe624;</i>
            <span class="listItem_text">经销加盟</span>
          </a>
        </div>
      </li>
      <li class="walk_into_jinduo_listItem">
        <div class="listItem_info">
          <a href="#">
            <i class="iconfont">&#xe649;</i>
            <span class="listItem_text">联系我们</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</section> -->
  </div>
</template>

<script>
import SETINFO from '@/constances/setInfo'
import {parameterOption} from '@/api/home'
import {
  getIframeSrc
} from "@/api/designerCenter";
import { nav } from "@/js/nav.js"; // 二级导航动画
import { IMAGE_PREFIX } from "@/constances/server";
import { mapState } from "vuex";
export default {
  name: "topMenu",
  data() {
    return {
      IMAGE_PREFIX,
      nav: {
        series: [],
        styles: [],
        categorys: [],
      },
    };
  },
  created() {
      //获取参数值-系列
      this.parameterOption(SETINFO.PARAM.SERIE_ID);
      //获取参数值- 品类
      this.parameterOption(SETINFO.PARAM.CATEGORY_ID);
      //获取参数值- 风格
      this.parameterOption(SETINFO.PARAM.STYLE_ID);
  },
  mounted() {
    this.$nextTick(() => {
      nav();
    });
  },
  computed: {
    ...mapState("user", ["current_nav", 'token','showConfirmModal','designer']),
  },
  methods: { 
   //参数值-列表
   async parameterOption(id){
      try {
        const res = await parameterOption({
          parameter_id: id
        })
        if (res.code === 0) {
          let list = res.data.data;
          switch (id) {
            case SETINFO.PARAM.SERIE_ID:
              this.nav.series  = list
              // this.nav.series  = list.concat(list,list,list,list,list,list)
              break;
            case SETINFO.PARAM.CATEGORY_ID:
              this.nav.categorys = list  
            case SETINFO.PARAM.STYLE_ID:
              this.nav.styles = list
              break;                                            
            default:
              break;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },         
    getURL(key, value){
      const keyMap = ['series_id','style_id','cate_id','space_id','spec_id']
      const query = keyMap.map((param,place)=>(param==key?value:'0')).join('-');
      // console.log('getURL query', query);
      const router = {
       path: `/product/list/${query}/`,
      }
      return  router
    },

    async goDesign(){
      if (this?.designer?.designer_detail?.id) {
        try {
          const res = await getIframeSrc({
            dest: 4,
          });
          window.open(
            res.data,
            '_blank'
          )
        } catch (error) {
          console.log('error getIframeSrc', error)
          this.$message.error(error.message || error)
        }
      } else {
        this.$store.commit("user/SWITCH_LOGIN", !this.showConfirmModal);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.param:nth-child(2){
  border-left: 1px #E0E1E6 solid;
  border-right: 1px #E0E1E6 solid;
}
.params_class{
  width: 1920px;
  height: 309px;
  padding: 30px 100px;
  display: flex;
  flex-flow: row;

  .param{
    width: 33%;
    padding: 0 48px 0 43px;
  }

  a:focus, a:hover {
    color: #B7937F;
  }

  a {
    color:#000000;
    font-size: 14px;
    display: block;
  }
  p {
    font-size:18px;
    margin:  0px 0px 30px 0;
    font-weight: 600;
    img{ vertical-align:middle; margin: 0 10px 2px 0;}
  } 

  ul{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px 44px;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
  }

  li{
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    &.more{
      position: absolute;
      top: calc(100% + 10px);
      left: 0;
      img{
        width: 16px;
        height: 16px;
        vertical-align: middle;
      }
    }
  }
}
.listItem_info{
  a{
    img.d,img.h{
      width: 56px;
      height: 77px;
      padding: 0 0 5px 0;
      object-fit: contain;
    }
    img.h{
      display: none;
    }
    &:hover{
      img{
        &.d{
          display: none;
        }
        &.h{
          display: inline-block;
        }
      }
    }
  }
}

</style>